import { ThemeDataContext } from "..";
import { useContext } from "react";

export const useThemeData = () => {
  const context = useContext(ThemeDataContext);
  if (!context) {
    throw new Error(
      "useThemeData must be used within a ThemeDataContext.Provider"
    );
  }
  return context;
};
